import React from "react";
import {RiepilogoGiustificativi} from "@commons/mapping/RiepilogoGiustificativiRecord";
import {floatFormat} from "@commons/utils/util";
import classNames from "classnames";
import {GiustificativoRecord, ShowFlagsWF} from "@commons/mapping/GiustificativoRecord";
import {IconCircleFilled} from "@tabler/icons-react";
import {Giustificativi} from "@commons/mapping/Giustificativi";

interface RiepilogoGiustProps {
    giustificativi?: RiepilogoGiustificativi[],
    listaGiustificativi: GiustificativoRecord[],
    toggleGiustificativo: (codice: string) => void,
    isHighlighted: (codice: string) => boolean,
    checkWfFlags?: boolean,
}

const RiepilogoGiust: React.FC<RiepilogoGiustProps> = ({giustificativi = [], listaGiustificativi, toggleGiustificativo, isHighlighted, checkWfFlags = true}) => {

    const showGiustificativo = function (codGiu: string | null) {
        if (checkWfFlags) {
            if (codGiu) {
                const giustificativo = listaGiustificativi.find(giu => giu.codGiu === codGiu);
                return (giustificativo ? (giustificativo.showFlagsWF & ShowFlagsWF.totali) === ShowFlagsWF.totali : true)
            } else return false;
        } else return true;
    }

    const getBgColorGiustificativo = function (bgColor: string | null, isHighlighted: boolean) {
        if (isHighlighted && bgColor) {
            return bgColor
        }
        if (isHighlighted && !bgColor) {
            return '#ffff00'
        }
    }

    const getCircleColor = function (giu: RiepilogoGiustificativi) {
        let giustHHType = giu.giustificativo.tipoOreGiu
        switch (giustHHType) {
            case "E":
            case "N":
            case "S":
            case "T":
            case "X":
                return 'text-hhEccedenti'
            case "M":
                return 'text-hhMancanti'
            default:
                return 'hidden'
        }
    }


    return <>
        <table className="tableRiepiloghi fontTableRiepiloghi">
            <caption className="tableRiepiloghiCaption fontTableRiepiloghiCaption">
                Riepilogo giustificativi
                <span className="overflow-ellipsis text-xs"> (quantit&agrave; orarie espresse in centesimi)</span>
            </caption>
            <thead>
            <tr className="tableRiepiloghiBorderB">
                <th className="tableRiepiloghiBorderR text-right pr-2 w-2/3">Giustificativo</th>
                <th className="text-center min-w-fit w-1/5">Totale</th>
            </tr>
            </thead>

            <tbody>
            {giustificativi
                .filter(giu => showGiustificativo(giu.giustificativo.codGiu))
                .sort(RiepilogoGiustificativi.compareFn)
                .map((giu, index) => {      /* itero nell'array giustificativi per inserirli nella tabella */
                    const giustificativo = listaGiustificativi.find(g => g.codGiu === giu.giustificativo.codGiu)!;
                    const giuIsHighlighted = isHighlighted(giustificativo.codGiu!);

                    return <tr key={giustificativo.codGiu} onClick={() => toggleGiustificativo(giustificativo.codGiu!)}
                               style={{backgroundColor: getBgColorGiustificativo(giustificativo.bgColor, giuIsHighlighted)}}>
                        <td className="tableRiepiloghiLabelTD">
                                        <span className="inline-flex">
                                            {giustificativo.descrizione}&nbsp;[{giustificativo.codGiu}]&nbsp;
                                            <span className="w-[15px] my-auto">
                                                {giustificativo.tipoGiu === 'O' && <IconCircleFilled className={classNames(getCircleColor(giu))} size={14}/>}
                                            </span>
                                        </span>
                        </td>
                        <td className="text-center">{floatFormat(giu.quantita)}</td>
                    </tr>
                })}
            </tbody>
        </table>
    </>
}

export default RiepilogoGiust;